import { STATUS_STYLES } from "@/lib/api";

export default function StatusBadge({ status }) {
  const cls = STATUS_STYLES[status] || "bg-slate-500/15 text-slate-300 border-slate-500/40";
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border ${cls}`}
      data-testid={`status-badge-${status?.toLowerCase().replace(/\s/g, "-")}`}
    >
      {status}
    </span>
  );
}
